import React from 'react';
import GridProductLookup from './index';
import { LookupRow } from './types';

export interface PreventiveTypeLookupHandlers {
  params?: string;
  PegarValorGrid: (row: LookupRow) => void;
  Iconeadd: () => void;
  Iconeditar: (row: LookupRow) => void;
  iconeExcluir?: (row: LookupRow) => void;
}

export function renderPreventiveTypeLookupGrid(
  handlers: PreventiveTypeLookupHandlers,
): React.ReactElement {
  return (
    <GridProductLookup
      endPoint="preventivetype/buscarpreventivetype"
      params={handlers.params ?? ''}
      listTitle="Tipos Preventiva"
      listSubtitle="Selecione um tipo ou cadastre um novo."
      newButtonLabel="Novo tipo"
      searchPlaceholder="Pesquisar tipos preventiva..."
      PegarValorGrid={handlers.PegarValorGrid}
      Iconeadd={handlers.Iconeadd}
      Iconeditar={handlers.Iconeditar}
      onDelete={handlers.iconeExcluir}
    />
  );
}
